import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/user_branches'
export default {
  namespaced: true,
  state: {
    dataList: [],
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
  },
  actions: {
    getDataList({ commit }) {
      commit('RESET_DATA_ITEM')
      axiosIns
        .post(ROOT_URL)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
        })
        .catch(error => console.error(error))
    },
  },
}
